module.exports = __webpack_public_path__ + "img/CM-SS-25-Volkswagen-Established.08bad05c.jpg";